import { SHStack } from "@components/design-systems";
import { useTheme } from "@mui/material";

interface VerticalDashLineProps {
  colNumber: number;
  isProjectionMode?: boolean;
}
export const VerticalDashLine = ({
  colNumber,
  isProjectionMode,
}: VerticalDashLineProps) => {
  const { palette } = useTheme();

  return (
    <SHStack
      direction={"row"}
      justifyContent={"space-between"}
      paddingLeft={"6.5px"}
    >
      {Array.from({ length: colNumber }).map((_, index) => {
        const isFirstItem = index === 0;
        const isLastItem = index === colNumber - 1;
        const isSecondLastItem = index === colNumber - 2;

        if (isProjectionMode) {
          return (
            <SHStack
              key={index}
              height={5}
              width={"100%"}
              justifyItems={"end"}
              direction={"row"}
              alignItems={"start"}
              justifyContent={isLastItem ? "space-between" : "flex-start"}
            >
              <SHStack
                width={"1px"}
                bgcolor={palette.text.primary}
                height={"100%"}
              />
              {isLastItem && (
                <SHStack
                  width={"1px"}
                  bgcolor={palette.text.primary}
                  height={"100%"}
                />
              )}
            </SHStack>
          );
        }

        return (
          <SHStack
            key={index}
            direction={"row"}
            width={"100%"}
            alignItems={isFirstItem ? "center" : "end"}
            justifyContent={isFirstItem ? "space-between" : "end"}
            marginRight={isFirstItem ? "15px" : "1.5px"}
            marginLeft={isLastItem ? "15px" : "1.5px"}
          >
            {isFirstItem && (
              <SHStack
                width={"1px"}
                height={"5px"}
                bgcolor={palette.text.primary}
              />
            )}

            <SHStack
              height={5}
              width={"1px"}
              bgcolor={palette.text.primary}
              marginRight={isFirstItem || isSecondLastItem ? "-8px" : "-1.5px"}
            />
          </SHStack>
        );
      })}
    </SHStack>
  );
};
